Array.prototype.indexOf || (Array.prototype.indexOf = function(a) {
        return jQuery.inArray(a, this)
    }),
    function() {
        var a, b, c;
        c = '<div class="pseudo-select" data-target="{{target}}">\n <div class="selected">\n        <span class="pseudo-val">{{selected}}</span>\n      <i class="icomoon-arrow-down"></i>\n    </div>\n    <ul>\n      {{#each options}}\n         <li data-pseudo-option="{{value}}">{{option}}</li>\n        {{/each}}\n </ul>\n</div>', b = Handlebars.compile(c), a = {
            initItem: function(c) {
                var d, e, f = c.attr("data-id"),
                    g = c.closest(".item-" + f),
                    h = jQuery(g).find("select.single-option-selector");
                return jQuery(".pseudo-select", g).remove(), e = 0, h.each(function() {
                    var a;
                    return jQuery(this).attr("data-no-pseudo") ? void 0 : (a = {
                        target: "pseudotarget" + e,
                        options: []
                    }, jQuery(this).attr("data-pseudo-select", a.target), jQuery(this).children("option").each(function() {
                        return a.options.push({
                            value: jQuery(this).val(),
                            option: jQuery(this).text()
                        })
                    }), a.selected = jQuery(this).find(":selected").text(), jQuery(this).after(b(a)), e += 1, jQuery(this).hide())
                }), jQuery(".pseudo-select", g).unbind("click"), jQuery(".pseudo-select", g).click(function() {
                    return jQuery(".pseudo-select", g).not(this).each(function() {
                        return jQuery(this).children("ul").slideUp("fast"), jQuery(this).children(".selected").removeClass("focus")
                    }), jQuery(this).children("ul").slideToggle("fast"), jQuery(this).children(".selected").toggleClass("focus")
                }), jQuery("[data-pseudo-option]", g).click(function() {
                    var a, b;
                    return a = jQuery(this).parent().parent(), b = a.data("target"), jQuery("select[data-pseudo-select='" + b + "']", g).val(jQuery(this).data("pseudo-option")).trigger("change"), jQuery(a).children(".selected").children(".pseudo-val").html(jQuery(this).html())
                }), d = function(b) {
                    return a = jQuery(".pseudo-select", g), a.is(b.target) || 0 !== a.has(b.target).length ? void 0 : (jQuery(a).children(".selected").removeClass("focus"), jQuery(a).children("ul").slideUp("fast"))
                }, jQuery(document).mousedown(function(a) {
                    return d(a)
                }), jQuery(document).bind("touchend", function(a) {
                    return d(a)
                })
            },
            initProduct: function() {
                var c, d, e = jQuery("#product"),
                    f = jQuery(e).find("select.single-option-selector");
                return jQuery(".pseudo-select", e).remove(), d = 0, f.each(function() {
                    var a;
                    return jQuery(this).attr("data-no-pseudo") ? void 0 : (a = {
                        target: "pseudotarget" + d,
                        options: []
                    }, jQuery(this).attr("data-pseudo-select", a.target), jQuery(this).children("option").each(function() {
                        return a.options.push({
                            value: jQuery(this).val(),
                            option: jQuery(this).text()
                        })
                    }), a.selected = jQuery(this).find(":selected").text(), jQuery(this).after(b(a)), d += 1, jQuery(this).hide())
                }), jQuery(".pseudo-select", e).unbind("click"), jQuery(".pseudo-select", e).click(function() {
                    return jQuery(".pseudo-select", e).not(this).each(function() {
                        return jQuery(this).children("ul").slideUp("fast"), jQuery(this).children(".selected").removeClass("focus")
                    }), jQuery(this).children("ul").slideToggle("fast"), jQuery(this).children(".selected").toggleClass("focus")
                }), jQuery("[data-pseudo-option]", e).click(function() {
                    var a, b;
                    return a = jQuery(this).parent().parent(), b = a.data("target"), jQuery("select[data-pseudo-select='" + b + "']", e).val(jQuery(this).data("pseudo-option")).trigger("change"), jQuery(a).children(".selected").children(".pseudo-val").html(jQuery(this).html())
                }), c = function(b) {
                    return a = jQuery(".pseudo-select", e), a.is(b.target) || 0 !== a.has(b.target).length ? void 0 : (jQuery(a).children(".selected").removeClass("focus"), jQuery(a).children("ul").slideUp("fast"))
                }, jQuery(document).mousedown(function(a) {
                    return c(a)
                }), jQuery(document).bind("touchend", function(a) {
                    return c(a)
                })
            }
        }, window.roar_pseudo = a, $(window).resize(function() {
            roar.handleSticky(), roar.detectOptions(), roar.mockupCaptionSlider(), roar.mockupCaptionVideo()
        }), $(window).scroll(function() {
            roar.handleSticky()
        }), jQuery(document).ready(function(a) {
            roar.isMobile() ? (roar.touch = !0, roar.clickEv = "touchstart", a("body").addClass("touch"), navigator.userAgent.match(/iPhone/i) ? a("body").addClass("iphone") : navigator.userAgent.match(/iPod/i) && a("body").addClass("ipod")) : a("body").addClass("notouch"), roar.init()
        })
    }.call(this);
var modalCloseButton = '<a class="close-modal" href="#" data-modal-close><i class="icomoon-cross"></i></a>',
    removeModalTimeoutID = -1,
    roar = {
        timeout: null,
        touch: !1,
        clickEv: "click",
        init: function() {
            roar.megaMenu(), roar.mockupCaptionVideo(), roar.handleSocialSharing(), roar.detectOptions(), roar.callbackImagesLoaded(), roar.handleTooltip(), roar.handleCountdown(), roar.handleTabs(), roar.handleSearch(), roar.handleSliding(), roar.callbackSearchMobile(), roar.buildProductItem(), roar.closeThemeModalEvents(), roar.handleCart(), roar.handleMenuMobile(), roar.handleCartSidebar(), roar.handleSlideshow(), roar.handleMap(), roar.handleDataAnimate(), roar.handleScrollToTop(), roar.handleSmoothScroll(), roar.mapFilters(), roar.affixProduct(), roar.handlVideo(), fakewaffle.responsiveTabs(["xs"])
        },
        megaMenu: function() {
            jQuery(".mega-menu").on("hover", ".item", function() {
                jQuery(".mega-menu .item").removeClass("hover"), jQuery(this).addClass("hover")
            })
        },
        handlVideo: function() {
            jQuery(".responsive-video iframe").each(function() {
                jQuery(this).removeAttr("height").removeAttr("width")
            }), jQuery(".responsive-video").fitVids({
                customSelector: "iframe[src^='https://w.soundcloud.com'], iframe[src^='http://myviiids.com']"
            })
        },
        affixProduct: function() {
            function a() {
                var a = jQuery("#product");
                if (a.length) {
                    var b = a.offset().left + a.outerWidth() - jQuery(".product-sidebar").outerWidth(),
                        c = a.offset().top,
                        d = a.outerHeight(!0),
                        e = c + d,
                        f = jQuery(".product-sidebar").outerHeight(!0),
                        g = jQuery("#header").outerHeight(!0);
                    jQuery("#phantom").length && (g = jQuery("#phantom").outerHeight(!0));
                    var h = jQuery(window).scrollTop(),
                        i = h + f;
                    c > h ? jQuery(".product-sidebar").removeClass("affix").removeClass("affix-bottom") : h >= c && e > i ? jQuery(".product-sidebar").removeClass("affix-bottom").addClass("affix").css("top", 0).css("left", b) : i >= e && jQuery(".product-sidebar").removeClass("affix").addClass("affix-bottom").attr("style", "").css("top", e - f - g)
                }
            }
            jQuery(window).scroll(function() {
                a()
            }), jQuery(window).resize(function() {
                a()
            }), a()
        },
        handleSocialSharing: function() {
            if (jQuery(".sharing-bubble").length) {
                var a = jQuery(".sharing-bubble"),
                    b = a.outerWidth();
                a.css("width", b).removeClass("fixed").addClass("absolute")
            }
        },
        subPrice: function(a, b) {
            var c = jQuery(a).closest(".item-" + b),
                d = jQuery(".cart-qty .quantity", c).val() || 1;
            d = parseInt(("" + d).replace(/[^0-9]/g, ""));
            var e = jQuery(".price-btn .sub_price", c).attr("data-price");
            e = parseInt(("" + e).replace(/[^0-9]/g, ""));
            var f = d * e;
            jQuery(".price-btn .sub_price", c).html(Shopify.formatMoney(f, window.money_format)), window.show_multiple_currencies && currenciesCallbackSpecial(".item-" + b + " span.money")
        },
        modifyQty: function(a, b, c) {
            var d = jQuery(a).closest(".qty"),
                e = jQuery(".quantity", d).val() || 1;
            return !(1 > (e = parseInt(("" + e).replace(/[^0-9]/g, ""))) + b || isNaN(e)) && (jQuery(".quantity", d).val(e + b), void(c && roar.subPrice(a, c)))
        },
        showThemeGallery: function(a, b, c) {
            jQuery(b).addClass("is_loading"), jQuery("#theme-gallery").remove();
            for (var d = jQuery(['<div id="theme-gallery" class="theme-modal">', '<div class="theme-gallery">', '<div class="theme-viewport swiper-container">', '<div class="theme-images swiper-wrapper">', "</div>", "</div>", '<div class="swiper-scrollbar"></div>', '<div class="theme-thumbs"></div>', "</div>", "</div>"].join("")).appendTo(jQuery("body")), e = d.find(".theme-images"), f = 0; f < a.length; f++) c != a[f] && jQuery('<div class="theme-img swiper-slide"/>').append(jQuery("<img/>").attr("src", a[f])).appendTo(e);
            d.find(".theme-images").clone().attr("class", "theme-thumbs-inner").appendTo(d.find(".theme-thumbs")).find(".theme-img").removeClass("swiper-slide").find("img").wrap('<a href="#"/>'), d.imagesLoaded(function() {
                roar.showThemeModal(d);
                var a = jQuery("#theme-gallery .swiper-container");
                jQuery(window).off(".themeGalleryResize").on("doThemeGalleryResizeCheck.themeGalleryResize resize.themeGalleryResize", function() {
                    var b = a.parent().height();
                    a.height(b), a.find("img").height(b)
                }).trigger("doThemeGalleryResizeCheck");
                var c = {
                    mode: "horizontal",
                    loop: !1,
                    slidesPerView: "auto",
                    slidesPerViewFit: !1,
                    resizeReInit: !0,
                    cssWidthAndHeight: !0,
                    calculateHeight: !1,
                    freeMode: !0,
                    freeModeFluid: !0,
                    scrollContainer: !0,
                    grabCursor: !0,
                    createPagination: !1
                };
                jQuery("html").hasClass("ie8") || jQuery.extend(c, {
                    scrollbar: {
                        container: ".swiper-scrollbar",
                        draggable: !1,
                        hide: !1,
                        snapOnRelease: !0
                    }
                });
                var e = a.swiper(c);
                jQuery("#theme-gallery .theme-thumbs").on("click", "a", function() {
                    return e.swipeTo(jQuery(this).parent().index(), 1e3), !1
                }), jQuery(b).removeClass("is_loading")
            })
        },
        showThemeModal: function(a) {
            roar.closeThemeModal(!0), jQuery(".theme-modal.temp").remove();
            var b = jQuery(a);
            b.appendTo("body").addClass("reveal").find(".modal-actions").remove(), b.prepend('<div class="modal-actions">' + modalCloseButton + "</div>"), roar.isPageScrollin() && jQuery("#page, #site-control").css("padding-right", jQuery.scrollBarWidth()), jQuery("body").addClass("modal-active")
        },
        closeThemeModal: function() {
            clearTimeout(roar.timeout), jQuery("a[data-modal-toggle].active").removeClass("active"), jQuery(".theme-modal.reveal").removeClass("reveal").addClass("unreveal"), jQuery("body").removeClass("modal-active")
        },
        closeThemeModalEvents: function() {
            jQuery(document).on("click", "body:not(.modal-active) a[data-modal-toggle]", function(a) {
                a.preventDefault(), jQuery(jQuery(this).data("modal-toggle")).removeClass("unreveal").addClass("reveal").find(":input[type=text]:visible:first").focus(), jQuery(this).addClass("active"), roar.isPageScrollin() && jQuery("body").css("padding-right", jQuery.scrollBarWidth()), jQuery("body").addClass("modal-active")
            }).on("keyup", function(a) {
                27 == a.which && roar.closeThemeModal()
            }), jQuery(document).on("click", "body.modal-active a[data-modal-close]", function(a) {
                a.preventDefault(), roar.closeThemeModal()
            }), jQuery(document).on("click", ".theme-modal", function(a) {
                a.target == this && (a.preventDefault(), roar.closeThemeModal(), jQuery(this).trigger("reset-modal"))
            }), jQuery(document).on("click", "body.modal-active a[data-modal-toggle]", function(a) {
                a.preventDefault(), roar.closeThemeModal(), jQuery(this).click()
            }), jQuery(document).on("click", "a[data-modal-target]", function(a) {
                a.preventDefault(), roar.showThemeModal($('<div class="theme-modal temp"/>').append($('<div class="inner"/>').html(jQuery(jQuery(this).data("modal-target")).wrapInner('<div class="container"/>').html())))
            })
        },
        isPageScrollin: function() {
            return jQuery("#page").outerHeight() > jQuery(window).height()
        },
        handleCart: function() {
            jQuery("#module-content").on("click", ".cart-toggle", function(a) {
                var b = jQuery(this);
                if ("false" != b.attr("data-once")) {
                    var d, e, f, g;
                    return g = b.closest(".product_item"), e = g.find(".cart"), f = g.find(".wrap"), d = g.find(".btns"), jQuery(".product_item").not(g).each(function() {
                        return jQuery(this).removeClass("border")
                    }), jQuery(".cart").not(e).each(function() {
                        return jQuery(this).removeClass("show")
                    }), jQuery(".btns").not(d).each(function() {
                        return jQuery(this).removeClass("hidden")
                    }), jQuery(".wrap").each(function() {
                        return jQuery(this).css({
                            height: "auto"
                        })
                    }), e.hasClass("show") || f.css({
                        height: e.outerHeight() + 2 + "px"
                    }), g.toggleClass("border"), e.toggleClass("show"), d.toggleClass("hidden"), a.preventDefault()
                }
                var h = b.attr("data-id"),
                    i = b.closest(".item-" + h),
                    j = jQuery(".product-select", i).attr("data-id"),
                    k = b.attr("data-handle"),
                    l = b.closest(".product_item").find(".icon_spinner2");
                l.show(), jQuery.getJSON("/products/" + k + ".js", function(c) {
                    b.attr("data-once", "true");
                    var d = function(a) {
                        if (a) jQuery(".price-btn", i).prop("disabled", !1).fadeTo(200, 1), jQuery(".price-btn .del", i).html("Add to cart"), a.available ? (jQuery(".cart-qty", i).show(), jQuery(".cart-out", i).hide()) : (jQuery(".cart-qty", i).hide(), jQuery(".cart-out", i).show()), jQuery(".price-val", i).html(a.compare_at_price > a.price ? '<span class="price">' + Shopify.formatMoney(a.price, window.money_format) + '</span><del class="price_compare">' + Shopify.formatMoney(a.compare_at_price, window.money_format) + "</del>" : '<span class="price">' + Shopify.formatMoney(a.price, window.money_format) + "</span>");
                        else {
                            jQuery(".price-val", i).empty(), jQuery(".price-btn", i).prop("disabled", !0).fadeTo(200, .5);
                            var c = a ? "Sold out" : "Unavailable";
                            jQuery(".price-btn .del", i).html('<span class="sold_out">' + c + "</span>")
                        }
                        jQuery(".price-btn .sub_price", i).attr("data-price", a.price).html(Shopify.formatMoney(a.price, window.money_format)), roar.subPrice(b, h), roar_pseudo.initItem(b), jQuery(".form-cart.show").parent().css({
                            height: jQuery(".form-cart.show").outerHeight() + "px"
                        }), window.show_multiple_currencies && currenciesCallbackSpecial(".item-" + h + " span.money")
                    };
                    new Shopify.OptionSelectors("product-select-" + j, {
                        product: c,
                        onVariantSelected: d
                    }), 1 == c.options.length && jQuery(".product-variants .selector-wrapper:eq(0)", i).prepend("<label>" + c.options[0].name + "</label>"), l.hide();
                    var e, f, g, k;
                    return k = b.closest(".product_item"), f = k.find(".cart"), g = k.find(".wrap"), e = k.find(".btns"), jQuery(".product_item").not(k).each(function() {
                        return jQuery(this).removeClass("border")
                    }), jQuery(".cart").not(f).each(function() {
                        return jQuery(this).removeClass("show")
                    }), jQuery(".btns").not(e).each(function() {
                        return jQuery(this).removeClass("hidden")
                    }), jQuery(".wrap").each(function() {
                        return jQuery(this).css({
                            height: "auto"
                        })
                    }), f.hasClass("show") || g.css({
                        height: f.outerHeight() + 2 + "px"
                    }), k.toggleClass("border"), f.toggleClass("show"), e.toggleClass("hidden"), a.preventDefault()
                })
            });
            $( ".buy-btn" ).click(function() {
              $( this ).toggleClass( "hidden" );
            });
            $( ".icomoon-cross" ).click(function() {
              $( ".buy-btn" ).removeClass( "hidden" );
            });
        },
        handleSortby: function() {
            void 0 !== window.sortby_default && window.sortby_default && (jQuery(".advanced-sortby .field").removeClass("active"), jQuery(".advanced-sortby .fields").find("[data-sort='" + window.sortby_default + "']").addClass("active"))
        },
        mapSingleFilter: function() {
            jQuery("#module-content").on("click", ".advanced-filter .field", function(a) {
                var b = jQuery(this),
                    c = b.data("handle"),
                    d = [];
                if (Shopify.queryParams.constraint && (d = Shopify.queryParams.constraint.split("+")), !window.enable_filter_multiple_choice && !b.hasClass("active")) {
                    var e = b.parents(".advanced-filter").find(".active");
                    e.length > 0 && e.each(function() {
                        var a = jQuery(this).data("handle");
                        if (jQuery(this).removeClass("active"), a) {
                            var b = d.indexOf(a);
                            b >= 0 && d.splice(b, 1)
                        }
                    })
                }
                if (c) {
                    var f = d.indexOf(c);
                    0 > f ? (d.push(c), b.addClass("active")) : (d.splice(f, 1), b.removeClass("active"))
                }
                d.length ? Shopify.queryParams.constraint = d.join("+") : delete Shopify.queryParams.constraint, roar.filterAjaxClick(), a.preventDefault()
            })
        },
        mapSingleCollection: function() {
            jQuery("#module-content").on("click", ".advanced-collection .field", function(a) {
                var b = jQuery(this);
                b.hasClass("active") || (delete Shopify.queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, delete Shopify.queryParams.sort_by, roar.filterAjaxClick(b.attr("href")), jQuery(".advanced-collection .field").removeClass("active"), b.addClass("active")), a.preventDefault()
            })
        },
        mapSingleSortby: function() {
            roar.handleSortby(), jQuery("#module-content").on("click", ".advanced-sortby .field", function(a) {
                var b = jQuery(this),
                    c = b.data("sort");
                b.hasClass("active") || (Shopify.queryParams.sort_by = c, roar.filterAjaxClick(), jQuery(".advanced-sortby .field").removeClass("active"), b.addClass("active")), a.preventDefault()
            })
        },
        mapSinglePagination: function() {
            jQuery("#module-content").on("click", ".advanced-pagination a", function(a) {
                var b = jQuery(this);
                delete Shopify.queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, delete Shopify.queryParams.sort_by, roar.filterAjaxClick(b.attr("href")), a.preventDefault()
            })
        },
        mapFilters: function() {
            roar.handleGridList(), roar.handleFilters(), roar.mapSingleFilter(), roar.mapSingleCollection(), roar.mapSingleSortby(), roar.mapSinglePagination()
        },
        filterCreateUrl: function(a) {
            var b = jQuery.param(Shopify.queryParams).replace(/%2B/g, "+");
            return a ? "" != b ? a + "?" + b : a : location.pathname + "?" + b
        },
        filterAjaxClick: function(a) {
            delete Shopify.queryParams.page;
            var b = roar.filterCreateUrl(a);
            roar.filterGetContent(b)
        },
        filterGetContent: function(a) {
            jQuery.ajax({
                type: "get",
                url: a,
                beforeSend: function() {
                    jQuery(".icon_spinner").show()
                },
                success: function(b) {
                    var c = b.match("<title>(.*?)</title>")[1];
                    jQuery("#filters").empty().html(jQuery(b).find("#filters").html()), jQuery("#sandBox").empty().html(jQuery(b).find("#sandBox").html()), jQuery(".advanced-pagination").empty().html(jQuery(b).find(".advanced-pagination").html()), jQuery("#breadcrumb").empty().html(jQuery(b).find("#breadcrumb").html()), jQuery(".infinite_scoll").removeClass("invisible").empty(), jQuery(".infinite_scoll").length && jQuery(b).find(".infinite_scoll").length && (jQuery(".infinite_scoll").removeClass("invisible").empty().html(jQuery(b).find(".infinite_scoll").html()), pInfScrMore = !0), History.pushState({
                        param: Shopify.queryParams
                    }, c, a), roar.buildProductItem(), setTimeout(function() {
                        jQuery("html,body").animate({
                            scrollTop: jQuery("#module-content .filter_wrap").offset().top
                        }, 500, "swing")
                    }, 100), jQuery(".icon_spinner").hide()
                },
                error: function() {
                    jQuery(".icon_spinner").hide()
                }
            })
        },
        handleFilters: function() {
            jQuery("#page").click(function(a) {
                jQuery(a.target).closest("#filters").length > 0 || jQuery("body").hasClass("filter-opened") && (jQuery(".filter-controller").removeClass("is_filter"), jQuery("html,body").removeClass("filter-opened"))
            }), jQuery("#filters").on("click", ".filter_close", function(a) {
                a.stopPropagation(), jQuery(".filter-controller").removeClass("is_filter"), jQuery("html,body").removeClass("filter-opened")
            }), jQuery(".filter-controller").click(function(a) {
                a.stopPropagation();
                var b = jQuery(this),
                    c = jQuery("body");
                b.hasClass("is_filter") ? (c.removeClass("filter-opened"), b.removeClass("is_filter"), b.children("span").text(b.attr("data-show"))) : (c.addClass("filter-opened"), b.addClass("is_filter"), b.children("span").text(b.attr("data-hide")))
            })
        },
        getHeightOfProductCase: function() {
            var a;
            return jQuery("#sandBox").hasClass("list") ? (a = jQuery(".product_item .displayed").parent().height(), a = a < window.list_height ? window.list_height : a) : (a = jQuery(".product_item").first().height(), a = a < window.grid_height ? window.grid_height : a), a
        },
        buildProductItem: function() {
            jQuery("select.product-select").each(function(a) {
                var b = new Date,
                    c = b.getTime() + a;
                jQuery(this).attr("id", "product-select-" + c).attr("data-id", c)
            })
        },
        createVariantsSwatch: function(a, b) {
            var c = new Array;
            if (window.swatch_size && c.push("Size"), window.swatch_color && (c.push("Color"), c.push("Colour")), c.length > 0) {
                var e = !1,
                    f = !1,
                    g = 0,
                    h = window.asset_url.substring(0, window.asset_url.lastIndexOf("?")),
                    k = window.asset_url.substring(window.asset_url.lastIndexOf("?"), window.asset_url.length);
                for (i = 0; i < a.options.length; i++) {
                    var l = "";
                    if (l = "object" == typeof a.options[i] ? a.options[i].name : a.options[i], e = !1, f = !1, c.indexOf(l) > -1) {
                        e = !0, g = i;
                        var m = l.toLowerCase();
                        if (/color|colour/i.test(m) && (f = !0), e) {
                            var n = "";
                            n += '<div class="swatch ' + m + ' clearfix" data-option-index="' + g + '">', n += '<div class="header"><span>' + l + "</span></div>";
                            var o = new Array;
                            for (j = 0; j < a.variants.length; j++) {
                                var p = a.variants[j],
                                    q = p.options[g],
                                    r = roar.convertToSlug(q),
                                    s = "swatch-" + g + "-" + r;
                                o.indexOf(q) < 0 && (n += '<div data-value="' + q + '" class="swatch-element ' + (f ? "color" : "") + r + (p.available ? " available " : " soldout ") + '">', f && (n += '<div class="tooltip">' + q + "</div>"), n += '<input id="' + s + '" type="radio" name="option-' + g + '" value="' + q + '"' + (0 == j ? " checked " : "") + (p.available ? "" : " disabled") + "/>", f ? (n += '<label for="' + s + '" style="background-color:' + r + "; background-image: url(" + h + r + ".png" + k + ')">', n += '<img class="crossed-out" src="' + h + 'soldout.png" />', n += "</label>") : (n += '<label for="' + s + '">' + q, n += '<img class="crossed-out" src="' + h + 'soldout.png" />', n += "</label>"), n += "</div>", o.push(q))
                            }
                            n += "</div>", b.find(".variants-wrapper > select").after(n), b.find(".swatch :radio").change(function() {
                                var a = jQuery(this).closest(".swatch").attr("data-option-index"),
                                    b = jQuery(this).val();
                                jQuery(this).closest("form").find(".single-option-selector").eq(a).val(b).trigger("change")
                            })
                        }
                    }
                }
            }
        },
        convertToSlug: function(a) {
            return a.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        isMobile: function() {
            var a = navigator.userAgent.toLowerCase();
            return !!(Modernizr.touch || a.match(/(iphone|ipod|ipad)/) || a.match(/(android)/) || a.match(/(iemobile)/) || a.match(/iphone/i) || a.match(/ipad/i) || a.match(/ipod/i) || a.match(/blackberry/i) || a.match(/bada/i) || a.match(/windows phone/i) || a.match(/webOS/i))
        },
        getWidthBrowser: function() {
            var a;
            return "number" == typeof window.innerWidth ? a = window.innerWidth : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? a = document.documentElement.clientWidth : document.body && (document.body.clientWidth || document.body.clientHeight) && (a = document.body.clientWidth), a
        },
        getHeightBrowser: function() {
            var a;
            return "number" == typeof window.innerHeight ? a = window.innerHeight : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? a = document.documentElement.clientHeight : document.body && (document.body.clientWidth || document.body.clientHeight) && (a = document.body.clientHeight), a
        },
        handleDataAnimate: function() {
            0 == roar.touch && jQuery(".animated").each(function() {
                var a = jQuery(this),
                    b = jQuery(this).attr("data-animation-delay"),
                    c = 0;
                if (c = b ? Number(b) : 200, !a.hasClass("visible")) {
                    var d = a.attr("data-animation");
                    a.appear(function() {
                        setTimeout(function() {
                            a.addClass(d + " visible")
                        }, c)
                    }, {
                        accX: 0,
                        accY: -30
                    }, "easeInCubic")
                }
            })
        },
        handleFocus: function() {
            jQuery(".form-focus input").focus(function() {
                jQuery(this).parents(".form-focus").addClass("focus")
            }).blur(function() {
                jQuery(this).parents(".form-focus").removeClass("focus")
            })
        },
        handleBoxLogin: function() {
            jQuery("#loginBox input").focus(function() {
                jQuery(this).parents("#loginBox").addClass("focus")
            }).blur(function() {
                jQuery(this).parents("#loginBox").removeClass("focus")
            })
        },
        handleScrollToTop: function() {
            function a(a) {
                var b = jQuery("#scroll-top");
                b.removeClass("off on"), b.addClass("on" == a ? "on" : "off")
            }
            jQuery(window).scroll(function() {
                var b = jQuery(this).scrollTop(),
                    c = jQuery(this).height();
                if (b > 0) var d = b + c / 2;
                else var d = 1;
                a(1e3 > d ? "off" : "on")
            }), jQuery("#scroll-top").click(function(a) {
                a.preventDefault(), jQuery("html,body").animate({
                    scrollTop: 0
                }, 800, "swing")
            })
        },
        handleTooltip: function() {
            jQuery(".btooltip").length && jQuery(".btooltip").tooltip()
        },
        handleTabs: function() {
            jQuery("body").on("click", ".nav-tabs a", function(a) {
                a.preventDefault(), jQuery(this).tab("show")
            })
        },
        getRandomInt: function(a, b) {
            return Math.floor(Math.random() * (b - a + 1)) + a
        },
        mockupCaptionVideo: function() {
            if (jQuery("#home-video").length) {
                if (roar.getWidthBrowser() < 1200) {
                    var a = window.general_font_size,
                        b = window.video_heading_size,
                        c = window.video_caption_size,
                        d = roar.getWidthBrowser(),
                        e = b * d / 1200,
                        f = c * d / 1200;
                    a > e && (e = a), a > f && (f = a), jQuery("#home-video .video_caption").css({
                        "font-size": f
                    }), jQuery("#home-video .video_heading").css({
                        "font-size": e
                    })
                } else {
                    var b = window.video_heading_size,
                        c = window.video_caption_size;
                    jQuery("#home-video .video_caption").css({
                        "font-size": c
                    }), jQuery("#home-video .video_heading").css({
                        "font-size": b
                    })
                }
                var g = jQuery("#home-video").height() / 2,
                    h = jQuery("#home-video .video_width").height(),
                    i = g - h / 2;
                jQuery("#home-video .video_width").css({
                    top: i,
                    opacity: 1
                })
            }
        },
        mockupCaptionSlider: function() {
            if (window.show_slideshow && jQuery("#home-slider").length) {
                var a = roar.getWidthBrowser(),
                    b = 30;
                jQuery("#home-slider .caption-content").each(1200 > a ? function() {
                    var c = jQuery(this).data("min"),
                        d = jQuery(this).data("max"),
                        e = d * a / 1200,
                        f = b * a / 1200;
                    c > e && (e = c), jQuery(this).css({
                        "font-size": e,
                        "padding-bottom": f
                    })
                } : function() {
                    var a = jQuery(this).data("max");
                    jQuery(this).css({
                        "font-size": a,
                        "padding-bottom": b
                    })
                });
                var c = jQuery("#home-slider").height() / 2;
                jQuery("#home-slider .slide-caption").each(function() {
                    if (1 == jQuery(this).data("position")) {
                        var d = jQuery(this).data("left"),
                            e = jQuery(this).data("top"),
                            f = jQuery(this).data("right"),
                            g = jQuery(this).data("bottom"),
                            h = jQuery(this).data("width"),
                            i = jQuery(this).data("align");
                        void 0 === e && (e = "auto"), void 0 === g && (g = "auto"), void 0 === d && (d = "auto"), void 0 === f && (f = "auto"), 1200 > a && ("auto" != d && (d = d * a / 1200), "auto" != e && (e = e * a / 1200), "auto" != f && (f = f * a / 1200), "auto" != g && (g = g * a / 1200), h = h * a / 1200), jQuery(this).css({
                            top: e,
                            left: d,
                            bottom: g,
                            right: f,
                            "max-width": h,
                            "text-align": i,
                            display: "inline-block",
                            opacity: 1,
                            width: "auto",
                            "line-height": 1
                        })
                    } else {
                        var j = jQuery(this).height(),
                            k = c - j / 2;
                        jQuery(this).css({
                            top: k,
                            opacity: 1
                        })
                    }
                })
            }
        },
        handleSlideshow: function() {
            window.show_slideshow && jQuery("#home-slider").length && (jQuery("#home-slider").flexslider({
                animation: "fade",
                prevText: "",
                nextText: "",
                slideshowSpeed: window.slideshow_interval,
                slideshow: window.slideshow_auto,
                controlNav: !1,
                start: function() {
                    jQuery("body").removeClass("loading")
                }
            }), imagesLoaded("#home-slider", function() {
                roar.mockupCaptionSlider()
            }))
        },
        handleMap: function() {
            jQuery("#contact_map").length && jQuery().gMap && jQuery("#contact_map").gMap({
                zoom: window.contact_zoom,
                scrollwheel: window.contact_scroll,
                maptype: window.contact_type,
                markers: [{
                    address: window.contact_address,
                    html: "_address",
                    icon: {
                        image: window.contact_icon,
                        iconsize: [188, 68],
                        iconanchor: [0, 68]
                    }
                }]
            })
        },
        handleGridList: function() {
            jQuery("#catSelectGrid").on(roar.clickEv, function() {
                jQuery("body").removeClass("cat-list"), jQuery("#catSelectList").removeClass("active"), jQuery(this).addClass("active")
            }), jQuery("#catSelectList").on(roar.clickEv, function() {
                jQuery("body").addClass("cat-list"), jQuery("#catSelectGrid").removeClass("active"), jQuery(this).addClass("active")
            })
        },
        handleSticky: function() {
            if (!jQuery("body").hasClass("templateProduct") && jQuery("#header").hasClass("sticky")) {
                var a = jQuery("#phantom").outerHeight(),
                    b = jQuery(window).scrollTop();
                if (b > a) {
                    b + jQuery(window).height() / 2 >= 1e3 && jQuery("#header").addClass("on")
                } else jQuery("#header").removeClass("on")
            }
        },
        handleCartSidebar: function() {
            jQuery(".cart-controller").click(function(a) {
                a.stopPropagation(), jQuery(".cart-sidebar").toggleClass("opened"), jQuery("html,body").toggleClass("cart-opened")
            }), jQuery("#page").click(function() {
                jQuery(".cart-sidebar").removeClass("opened"), jQuery("html,body").removeClass("cart-opened")
            })
        },
        handleMenuMobile: function() {
            jQuery("#page").click(function() {
                jQuery(".menu-mobile").removeClass("opened"), jQuery("html,body").removeClass("menu-opened")
            }), jQuery("[data-toggle=offcanvas]").click(function(a) {
                a.stopPropagation(), jQuery(".menu-mobile").toggleClass("opened"), jQuery("html,body").toggleClass("menu-opened")
            }), jQuery(".is-mobile .menu-mobile .mobile_nav .expand").click(function() {
                var a = jQuery(this).parents(".parent_submenu").first();
                a.hasClass("is_open") ? a.removeClass("is_open") : a.addClass("is_open"), a.find(".dropdown_menu").first().slideToggle()
            })
        },
        handleSearch: function() {
            jQuery(".site-search-toggle").click(function() {
                var a = jQuery("#header");
                a.hasClass("is_search") ? a.removeClass("is_search") : (a.addClass("is_search"), jQuery("#input-ajax").focus())
            }), jQuery(".site-search-trigger").click(function() {
                jQuery(".search-menu-icon .site-search-toggle").trigger("click")
            })
        },
        handleSliding: function() {
            jQuery(".sb-toggle-wrapper").click(function() {
                var a = jQuery("#top");
                a.hasClass("is_sliding") ? a.removeClass("is_sliding") : a.addClass("is_sliding"), jQuery("#slidingbar").slideToggle()
            })
        },
        callbackSearchMobile: function() {
            var a = jQuery(".is-mobile .is-mobile-search .fa-search"),
                b = jQuery(".is-mobile .is-mobile-search .fa-times"),
                c = jQuery(".is-mobile .is-mobile-search .input-search"),
                d = jQuery(".is-mobile .is-mobile-search");
            a.click(function() {
                d.addClass("on"), c.focus()
            }), c.click(function() {
                return !1
            }), b.click(function() {
                d.removeClass("on")
            })
        },
        handleCountdown: function() {
            jQuery(".count_holder_big").each(function() {
                var a = jQuery(this).find(".count_holder_small");
                jQuery(this).hover(function() {
                    a.addClass("hover").appendTo("body")
                }, function() {
                    a.removeClass("hover").appendTo(this)
                }).mousemove(function(b) {
                    var c = b.pageX + 60,
                        d = b.pageY - 50,
                        e = a.width(),
                        g = (a.height(), jQuery(window).width() - (c + e));
                    jQuery(window).height(), 50 > g && (c = b.pageX - e - 60), a.css({
                        left: c,
                        top: d
                    })
                })
            })
        },
        handleSmoothScroll: function() {
            jQuery("body").on("click", ".smoothscroll", function(a) {
                a.preventDefault();
                var b = jQuery(this).attr("href");
                jQuery(b).trigger("click"), setTimeout(function() {
                    jQuery("html,body").animate({
                        scrollTop: jQuery("#product-reviews").offset().top - 100
                    }, 800, "swing")
                }, 300)
            })
        },
        notifyIE7Users: function() {
            if (jQuery("html").hasClass("ie7") || jQuery("html").hasClass("ie7"))
                if (window.notify_ie7_page) jQuery.ajax({
                    type: "GET",
                    url: "pages/" + window.notify_ie7_page,
                    beforeSend: function() {},
                    success: function(a) {
                        var b = jQuery(a).find("#col-main > .page > .page_content");
                        jQuery("body").html(b.html()).show()
                    },
                    dataType: "html"
                });
                else {
                    var a = "<h1>Unsupported Browser</h1>";
                    jQuery("body").html(a).show()
                }
        },
        detectOptions: function() {
            roar.getWidthBrowser() < 992 ? jQuery("#product-header-first").is(":empty") && jQuery("#product-header").detach().appendTo("#product-header-first") : jQuery("#product-header-first").is(":empty") || jQuery("#product-header").detach().appendTo("#product-header-last")
        },
        callbackImagesLoaded: function() {
            jQuery(".featured-collections-child").length && jQuery(".featured-collections-child").owlCarousel({
                navigation: !0,
                pagination: !1,
                mouseDrag: !1,
                items: 2,
                itemsDesktop: [1199, 3],
                itemsDesktopSmall: [991, 2],
                itemsTablet: [767, 2],
                itemsTabletSmall: [480, 1],
                itemsMobile: !1,
                scrollPerPage: !0,
                navigationText: ['<span class="btn"><i class="icomoon-arrow-left"></i></span>', '<span class="btn"><i class="icomoon-arrow-right"></i></span>'],
                beforeMove: function(a) {
                    if (0 == roar.touch) {
                        jQuery(a).find(".animated").removeClass("animated").unbind("appear")
                    }
                }
            }), jQuery("#our-partner").length && jQuery("#our-partner").owlCarousel({
                navigation: !0,
                pagination: !1,
                mouseDrag: !1,
                items: 5,
                itemsDesktop: [1199, 5],
                itemsDesktopSmall: [991, 4],
                itemsTablet: [768, 3],
                itemsTabletSmall: [767, 3],
                itemsMobile: [479, 2],
                scrollPerPage: !1,
                navigationText: ['<span class="btn"><i class="icomoon-arrow-left"></i></span>', '<span class="btn"><i class="icomoon-arrow-right"></i></span>'],
                beforeMove: function(a) {
                    if (0 == roar.touch) {
                        jQuery(a).find(".animated").removeClass("animated").unbind("appear")
                    }
                }
            }), jQuery("#special-offers").length && jQuery("#special-offers").owlCarousel({
                navigation: !0,
                pagination: !1,
                mouseDrag: !1,
                items: 3,
                itemsDesktop: [1199, 3],
                itemsDesktopSmall: [991, 3],
                itemsTablet: [767, 2],
                itemsTabletSmall: [480, 1],
                itemsMobile: !1,
                scrollPerPage: !1,
                navigationText: ['<i class="icomoon-arrow-left"></i>', '<i class="icomoon-arrow-right"></i>'],
                beforeMove: function(a) {
                    if (0 == roar.touch) {
                        jQuery(a).find(".animated").removeClass("animated").unbind("appear")
                    }
                }
            }),jQuery("#best-seller").length && jQuery("#best-seller").owlCarousel({
                navigation: !0,
                pagination: !1,
                mouseDrag: !0,
                items: 1,
                itemsDesktop: [1199, 1],
                itemsDesktopSmall: [991, 1],
                itemsTablet: [767, 1],
                itemsTabletSmall: [480, 1],
                itemsMobile: !1,
                scrollPerPage: !1,
                navigationText: ['<i class="icomoon-arrow-left"></i>', '<i class="icomoon-arrow-right"></i>'],
                beforeMove: function(a) {
                    if (0 == roar.touch) {
                        jQuery(a).find(".animated").removeClass("animated").unbind("appear")
                    }
                }
            }), jQuery("#product-images-portrait").length && jQuery("#product-images-portrait").owlCarousel({
                navigation: !0,
                pagination: !0,
                mouseDrag: !1,
                items: 1,
                itemsDesktop: [1199, 1],
                itemsDesktopSmall: [991, 1],
                itemsTablet: [767, 1],
                itemsTabletSmall: [480, 1],
                itemsMobile: !1,
                scrollPerPage: !1,
                navigationText: ['<i class="icomoon-arrow-left"></i>', '<i class="icomoon-arrow-right"></i>'],
                beforeMove: function(a) {
                    if (0 == roar.touch) {
                        jQuery(a).find(".animated").removeClass("animated").unbind("appear")
                    }
                }
            })
        }
    };